import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

type TrackingBody = {
  page: string
  optionalData?: string
  latitude?: string
  longitude?: string
}

export async function postTracking(body: TrackingBody, options?: FetchOptions): Promise<void> {
  const url = `${BASE}/api/v1/tracking`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    await api.post<unknown>(url, body, options)
  } catch (e) {
    // トラッキングは失敗しても UX に影響しないため、エラーはログのみ
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
  }
}
